export function defaultInfoFormat(percent) {
  return "".concat(percent, "%");
}
export function getCirclePath(pos, radius) {
  var start = pos.start,
      end = pos.end;
  return "M 50 50 m ".concat(start.x, ",").concat(start.y, "\n          a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(end.x, ",").concat(end.y, "\n          a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-1 * end.x, ",").concat(-1 * end.y);
}
export function getPosition(gapPos, radius) {
  var start = {
    x: 0,
    y: -radius
  };
  var end = {
    x: 0,
    y: 2 * radius
  };

  switch (gapPos) {
    case 'left':
      start = {
        x: -radius,
        y: 0
      };
      end = {
        x: 2 * radius,
        y: 0
      };
      break;

    case 'right':
      start = {
        x: radius,
        y: 0
      };
      end = {
        x: -2 * radius,
        y: 0
      };
      break;

    case 'bottom':
      start = {
        x: 0,
        y: radius
      };
      end = {
        x: 0,
        y: -2 * radius
      };
      break;

    default:
      break;
  }

  return {
    start: start,
    end: end
  };
}